export default function Careers() {
  const positions = [
    {
      icon: 'ri-building-line',
      title: 'Civil & Structural Engineering',
      description: 'Lead infrastructure projects with innovative engineering solutions'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Project Management',
      description: 'Oversee complex projects from conception to completion'
    },
    {
      icon: 'ri-earth-line',
      title: 'Mining & Geological Services',
      description: 'Drive sustainable mining operations with technical expertise'
    },
    {
      icon: 'ri-vip-diamond-line',
      title: 'Gems & Jewellery Experts',
      description: 'Curate and manage premium gems and jewellery collections'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Business Development',
      description: 'Expand our market presence and forge strategic partnerships'
    }
  ];

  return (
    <section id="careers" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Join Our Team</h2>
          <div className="w-24 h-1 bg-[#C9A961] mx-auto mb-6"></div>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Build your career with a leading conglomerate committed to excellence and innovation
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
          {positions.map((position, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:border-[#C9A961] transition-all duration-300 group hover:shadow-xl"
            >
              <div className="w-14 h-14 bg-gradient-to-br from-[#C9A961] to-[#B89851] rounded-lg flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                <i className={`${position.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">{position.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{position.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-br from-[#C9A961] to-[#B89851] p-12 rounded-2xl text-center text-white">
          <h3 className="text-3xl font-bold mb-4">Ready to Make an Impact?</h3>
          <p className="text-lg mb-8 opacity-90">
            Send your resume and cover letter to start your journey with Vertak Group
          </p>
          <a
            href="mailto:careers@vertakgroup.com"
            className="inline-flex items-center px-8 py-4 bg-white text-[#C9A961] text-base font-medium rounded-lg hover:bg-gray-100 transition-all whitespace-nowrap"
          >
            <i className="ri-mail-line text-xl mr-2"></i>
            careers@vertakgroup.com
          </a>
        </div>
      </div>
    </section>
  );
}